/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import ReasonConfirmModal from '../ReasonConfirmModal';

// ---------------------------------------------------------------------------
// Modal de EXCLUSÃO de movimento (handoff 0095).
//
// A exclusão exige motivo (`cancelled_reason`, 8–255 chars após trim) — a
// validação espelha a do backend: o 422 é a rede de segurança, não a
// experiência. Confirmar dispara `onConfirm(motivoTrimado)`; o submit e o
// tratamento de erro ficam na página (o modal permanece aberto em falha).
//
// A mecânica (campo + contador + validação + botões G.1) virou o primitivo
// compartilhado `ReasonConfirmModal` em 2026-08-19, quando a exclusão de anexo
// da régua de cobrança pediu o mesmo molde (FC7 cap.2 H.4: extrair, não
// copiar). Este arquivo continua sendo a API pública do Movements — a
// microcópia daqui não mudou.
// ---------------------------------------------------------------------------

export default function DeleteMovementModal({
   isOpen,
   movementId,
   isSubmitting = false,
   onCancel,
   onConfirm,
}) {
   return (
      <ReasonConfirmModal
         isOpen={isOpen}
         title="Excluir movimento"
         subtitle={movementId ? `Movimento #${movementId}` : null}
         infoText={
            <>
               A exclusão cria um <strong>movimento reverso</strong> que devolve
               o efeito no estoque. Informe o motivo — ele fica registrado no
               movimento excluído.
            </>
         }
         reasonLabel="Motivo da exclusão"
         placeholder="Ex.: Nota lançada no PDV errado"
         minLength={8}
         maxLength={255}
         confirmLabel="Excluir movimento"
         submittingLabel="Excluindo…"
         cancelLabel="Voltar"
         isSubmitting={isSubmitting}
         inputId="delete-movement-reason"
         maxWidth="560px"
         onCancel={onCancel}
         onConfirm={onConfirm}
      />
   );
}

DeleteMovementModal.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   movementId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   isSubmitting: PropTypes.bool,
   onCancel: PropTypes.func.isRequired,
   onConfirm: PropTypes.func.isRequired,
};
